"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bookingDataActions = require("actions/bookingDataActions");

function linkedBookings() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _bookingDataActions.LINKED_BOOKINGS_DATA_RECEIVED:
            if (action.linkedBookingsData) {
                return action.linkedBookingsData;
            } else {
                return state;
            }
        default:
            return state;
    }
}

exports.default = linkedBookings;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/reducers/linkedBookings.js
// module id = 1399
// module chunks = 0